import { Download } from "lucide-react";
import { useState } from "react";
import { secureDownload, logPortalAction } from "../helpers.js";

export default function DownloadBtn({ fileUrl, filename, label, primaryColor, resourceType, resourceId }) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (!fileUrl) return;
    setLoading(true);
    await logPortalAction("download", resourceType || "document", resourceId || "", filename || "");
    await secureDownload(fileUrl, filename || "document");
    setLoading(false);
  };

  return (
    <button onClick={handleClick} disabled={loading}
      className="flex items-center gap-1.5 text-xs font-medium px-2.5 py-1.5 rounded-lg transition hover:opacity-80 disabled:opacity-50"
      style={{ backgroundColor: `${primaryColor}10`, color: primaryColor }}
      data-testid={`download-btn-${resourceId || "file"}`}>
      <Download className="w-3.5 h-3.5" />
      {loading ? "..." : (label || "Telecharger")}
    </button>
  );
}
